import {
  Box,
  Button,
  Checkbox,
  Grid,
  FormGroup,
  FormControlLabel,
  Typography
} from "@mui/material";
import { toast } from "react-hot-toast";
import PageHeader from "../components/ui/PageHeader";
import CustomInput from "../components/ui/CustomInput";
import DownloadExcelModal from "../components/Modals/DownloadExcelModal";

import { useRef, useState, useEffect } from "react";
import axios from "../api/axiosClient";
import PageForm from "../components/ui/PageForm";
import DownloadIcon from "@mui/icons-material/Download";

import { useLoading } from "../components/LoadingContext";
import { handleError, getFilledOrNullString, getFilledOrEmptyArray, getDateAsISOString } from "../services/serviceBase";
import { useIntl } from "react-intl";
import { getExcelReports, runReportDownload, getExcelReportFieldSets } from "../services/exportService";
import * as apiService from "../services/apiService";
import { Today } from "@mui/icons-material";

const TKExcelReports = (props) => {
  const intl = useIntl();
  const [excelReports, setExcelReports] = useState([]);
  const [selectedReport, setSelctedReport] = useState("");

  const [excelReportFiledsets, setExcelReportFiledsets] = useState("");
  const [selectedFieldset, setSelectedFieldset] = useState("");

  const [departments, setDepartments] = useState([]);
  const [companies, setCompanies] = useState([]);

  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);

  const [year, setYear] = useState("");
  const [number, setNumber] = useState("");
  const [split, setSplit] = useState("");
  const [messageId, setMessageId] = useState("");
  const [sapInboundDelivery, setSapInboundDelivery] = useState("");
  const [vendorNumber, setVendorNumber] = useState("");

  const [modalName, setModalName] = useState("");

  const [tableHeight, setTableHeigth] = useState(260);
  const [fields, setFields] = useState([]);
  const [checked, setChecked] = useState([]);
  const [availableColumns, setAvailableColumns] = useState([]);
  const [chosenColumns, setChosenColumns] = useState([]);

  const [downloadLink, setDownloadLink] = useState("");
  const [openDownloadModal, setOpenDownloadModal] = useState(false);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [isInError, setIsInError] = useState(false);

  const { setLoading } = useLoading();

  const resizeTable = () => {
    var fromHeight = document.querySelector("#form").clientHeight;
    var pageHeight = window.innerHeight;
    var tableHeight = pageHeight - fromHeight - 400;
    setTableHeigth(tableHeight);
  };

  useEffect(() => {
    window.addEventListener("resize", resizeTable);
    return () => {
      window.removeEventListener("resize", resizeTable);
    };
  }, []);

  const handletrasitionEnd = () => {
    resizeTable();
  };

  const modalStyle = {
    position: "absolute",
    top: "20%",
    left: "50%",
    width: "400px",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    p: 4,
    borderRadius: 2,
  };

  const getReports = async () => {
    setLoading(true);
    getExcelReports(
      props.exportType,
      (response) => {
        setLoading(false);
        var selectItems = [];
        if (response !== undefined && response != null) {
          response.map((x) => {
            selectItems.push({
              value: x.idExcelReport,
              text: x.excelReportName,
            });
          });
        }
        setExcelReports(selectItems);
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      }
    );
  };

  const getDepartments = async () => {
    apiService.getDepartments(
      (response) => {
        setLoading(false);
        var selectDepartmentItems = [];
        if (response !== undefined) {
          response.map((x) => {
            selectDepartmentItems.push({ value: x.id, text: x.departmentCode });
          });
        }
        setDepartments(selectDepartmentItems);
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      }
    );
  };

  const getCompanyList = async () => {
    apiService.getCompanies(
      (response) => {
        setLoading(false);
        var selectCompanyItems = [];
        if (response !== undefined) {
          response.map((x) => {
            selectCompanyItems.push({
              value: x.idCompany,
              text: x.companyDescription,
            });
          });
        }
        setCompanies(selectCompanyItems);
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      }
    );
  };

  useEffect(() => {
    getDepartments();
    getCompanyList();
  }, []);

  useEffect(() => {
    getReports();
  }, [props.exportType]);

  const getFieldSet = async () => {
    setLoading(true);
    getExcelReportFieldSets(
      selectedReport,
      (response) => {
        setLoading(false);
        var selectItems = [];
        if (response !== undefined && response != null) {
          response.map((x) => {
            selectItems.push({
              value: x.idExcelReportFieldSet,
              text: x.excelReportFieldSetName,
            });
          });
        }
        setSelectedFieldset(selectItems[0].value);
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      }
    );
  };

  const getFields = async () => {
    setLoading(true);
    axios
      .get("excelreports/" + selectedReport + "/fields")
      .then((response) => {
        setLoading(false);
        setFields(response.data);
        setAvailableColumns(response.data);
        setChosenColumns([]);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  useEffect(() => {
    if (
      selectedReport !== "" &&
      selectedReport !== undefined &&
      selectedReport !== null
    ) {
      getFieldSet();
      getFields();
    } else {
      setSelectedFieldset("");
      setExcelReportFiledsets("");
      setFields([]);
      setAvailableColumns([]);
    }
  }, [selectedReport]);

  const getFieldsByFieldSet = async () => {
    setLoading(true);
    axios
      .get("excelreports/" + selectedReport + "/fieldset/" + selectedFieldset)
      .then((response) => {
        setLoading(false);
        var selectedColumns = [];
        if (response.data !== undefined && response.data != null) {
          response.data.map((x) => {
            selectedColumns.push(x.excelReportFieldSetMappingName);
          });
        }

        let newLeft = [];
        fields.map((x) => newLeft.push(x));

        selectedColumns.map((x) => {
          var leftIndex = newLeft.indexOf(x);
          newLeft.splice(leftIndex, 1);
        });

        setChosenColumns(selectedColumns);
        setAvailableColumns(newLeft);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleRun = () => {
    var data = {
      IdExcelReportFieldSet: getFilledOrNullString(selectedFieldset),
      IdCompanyList: getFilledOrEmptyArray(selectedCompanies),
      IdRFDepartmentList: getFilledOrEmptyArray(selectedDepartments),
      SapInboundDelivery: getFilledOrNullString(sapInboundDelivery),
      MessageId: getFilledOrNullString(messageId),
      RFYear: getFilledOrNullString(year),
      RFNumber: getFilledOrNullString(number),
      RFSplit: getFilledOrNullString(split),
      VendorNumber: getFilledOrNullString(vendorNumber),
      DateFrom: getDateAsISOString(fromDate),
      DateTo: getDateAsISOString(toDate),
      InError: isInError,
      IncludeRFClosed: true
    };

    setLoading(true);

    runReportDownload(
      selectedReport,
      data,
      (response) => {
        setLoading(false);
        setDownloadLink(response);
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      }
    );
  };

  useEffect(() => {
    if (modalName !== "" && modalName !== undefined && modalName !== null) {
      var currentFieldSet = excelReportFiledsets.find(
        (x) => x.text == modalName
      );
      if (currentFieldSet != null) {
        setSelectedFieldset(currentFieldSet.value);
      }
    }
  }, [excelReportFiledsets]);

  useEffect(() => {
    if (
      selectedFieldset !== "" &&
      selectedFieldset !== undefined &&
      selectedFieldset !== null
    ) {
      getFieldsByFieldSet();
    } else {
      setChosenColumns([]);
      if (
        selectedReport !== "" &&
        selectedReport !== undefined &&
        selectedReport !== null
      ) {
        getFields();
      }
    }
  }, [selectedFieldset]);

  const handleCheckBoxChange = (event) => {
    setIsInError(event.target.checked);
  };

  return (
    <Box>
      <PageHeader title={props.exportType == 'TKI' ? "TK Inbound" : "TK Outbound"} />

      <Box sx={{ mt: 0.5 }}>
        <PageForm
          adjustHeightFunc={handletrasitionEnd}
          form={
            <form>
              <Grid container spacing={2}>
                <Grid item md={4}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "General.Brand" })}
                    type="multiselect"
                    valueRef={selectedCompanies}
                    selectItems={companies}
                    setValue={setSelectedCompanies}
                    inputCol={10}
                    textCol={2}
                  />
                </Grid>
                <Grid item md={4}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "TKExcelReports.VendorNumber",
                    })}
                    type="text"
                    value={vendorNumber}
                    setValue={setVendorNumber}
                    inputCol={7}
                    textCol={5}
                  />
                </Grid>
                <Grid item md={4}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "TKExcelReports.SapInboundDelivery",
                    })}
                    type="text"
                    value={sapInboundDelivery}
                    setValue={setSapInboundDelivery}
                    inputCol={6}
                    textCol={6}
                  />
                </Grid>
                <Grid item md={1}>
                  <Typography mt={1} sx={{color: "rgba(0, 0, 0, 0.6)"}}>Dossier:</Typography>
                </Grid>
                <Grid item md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "TKExcelReports.Year" })}
                    type="number"
                    value={year}
                    setValue={setYear}
                    inputCol={9}
                    textCol={3}
                  />
                </Grid>
                <Grid item md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "TKExcelReports.Department" })}
                    type="multiselect"
                    valueRef={selectedDepartments}
                    selectItems={departments}
                    setValue={setSelectedDepartments}
                    inputCol={7}
                    textCol={5}
                  />
                </Grid>
                <Grid item md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "TKExcelReports.Number" })}
                    type="number"
                    value={number}
                    setValue={setNumber}
                    inputCol={8}
                    textCol={4}
                  />
                </Grid>
                <Grid item md={2}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "TKExcelReports.Split" })}
                    type="number"
                    value={split}
                    setValue={setSplit}
                    inputCol={7}
                    textCol={5}
                  />
                </Grid>
                <Grid item md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "RASearch.FromDate",
                    })}
                    type="date"
                    valueRef={fromDate}
                    setValue={setFromDate}
                    textCol={4}
                    inputCol={8}
                  />
                </Grid>
                <Grid item md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "RASearch.ToDate",
                    })}
                    type="date"
                    valueRef={toDate}
                    setValue={setToDate}
                    textCol={4}
                    inputCol={8}
                  />
                </Grid>
                <Grid item md={6}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "TKExcelReports.MessageId",
                    })}
                    type="text"
                    value={messageId}
                    setValue={setMessageId}
                    inputCol={9}
                    textCol={3}
                  />
                </Grid>
                <Grid item md={6}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isInError}
                            onChange={handleCheckBoxChange}
                          />
                        }
                        label={intl.formatMessage({
                          id: "FASTExtractions.InError",
                        })}
                      />
                    </FormGroup>
                  </Grid>
              </Grid>
            </form>
          }
        />
      </Box>
      <Box id="form1" sx={{ mt: 2 }}>
        <Grid container>
          <Grid item sm={6}>
            <CustomInput
              labelText={intl.formatMessage({ id: "ExcelReports.Title" })}
              type="select"
              valueRef={selectedReport}
              selectItems={excelReports}
              setValue={setSelctedReport}
              inputCol={9}
              textCol={3}
            />
          </Grid>
          <Grid item sm={0.5}></Grid>
          <Grid item sm={1.5}>
            <Button
                variant="contained"
                sx={{ width: "100%" }}
                className="apeLigthBlueBackground"
                startIcon={<DownloadIcon />}
                onClick={handleRun}
              >
                {intl.formatMessage({ id: "ExcelReports.Run" })}
              </Button>
          </Grid>
        </Grid>
      </Box>
      <DownloadExcelModal
        downloadLink={downloadLink}
        openDownloadModal={openDownloadModal}
      ></DownloadExcelModal>
    </Box>
  );
};

export default TKExcelReports;
